import { render, staticRenderFns } from "./UserSearchCriteria.vue?vue&type=template&id=22d80c72"
import script from "./UserSearchCriteria.vue?vue&type=script&lang=ts"
export * from "./UserSearchCriteria.vue?vue&type=script&lang=ts"
import style0 from "./UserSearchCriteria.vue?vue&type=style&index=0&id=22d80c72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports